/* Zen & Zip — PDP "add to wishlist" heart button (snippets/product-form-block.liquid).
   Shares the localStorage wishlist from zz-wishlist.js. Repaints on load, on
   'zz:wishlist:change', and after any DOM swap (the button is re-rendered by
   Shopify's variant-change section refresh, so a body-level MutationObserver
   -- guarded against our own writes -- is the reliable way to catch it). */
(function () {
  function isSaved(variantId) {
    return window.ZZWishlist.read().some(function (i) {
      return String(i.variantId) === String(variantId);
    });
  }

  function paint(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    var saved = isSaved(variantId);
    btn.classList.toggle('is-saved', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    var label = saved ? 'Remove from wishlist' : 'Add to wishlist';
    btn.setAttribute('aria-label', label);
    btn.setAttribute('title', label);
    var svg = btn.querySelector('svg');
    if (svg) svg.setAttribute('fill', saved ? 'currentColor' : 'none');
  }

  function paintAll() {
    document.querySelectorAll('[data-zz-wishlist-toggle]').forEach(paint);
  }

  var selfUpdating = false;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-zz-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    selfUpdating = true;
    if (isSaved(variantId)) {
      window.ZZWishlist.remove(variantId);
    } else {
      window.ZZWishlist.add({
        variantId: variantId,
        url: btn.getAttribute('data-product-url'),
        title: btn.getAttribute('data-title'),
        variantTitle: btn.getAttribute('data-variant-title'),
        image: btn.getAttribute('data-image'),
        price: btn.getAttribute('data-price')
      });
    }
    paint(btn);
  });

  document.addEventListener('zz:wishlist:change', paintAll);
  document.addEventListener('DOMContentLoaded', paintAll);

  if ('MutationObserver' in window) {
    var scheduled = false;
    new MutationObserver(function () {
      if (selfUpdating) {
        selfUpdating = false;
        return;
      }
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        paintAll();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
